import type { ReactNode } from 'react'
import { AlertIcon, CheckIcon, InfoIcon, WarningIcon } from '@/components/icons'
import { cx } from './internal/cx'
import './StatusChip.css'

export type StatusChipStatus = 'success' | 'warning' | 'error' | 'info' | 'neutral'

export type StatusChipProps = {
  status: StatusChipStatus
  children: ReactNode
}

const STATUS_ICON: Record<StatusChipStatus, ReactNode> = {
  success: <CheckIcon size={14} />,
  warning: <WarningIcon size={14} />,
  error: <AlertIcon size={14} />,
  info: <InfoIcon size={14} />,
  neutral: <span className="ui-status-chip__dot" />,
}

/** Compact status badge: icon + visible text, never color alone. */
export function StatusChip({ status, children }: StatusChipProps) {
  return (
    <span className={cx('ui-status-chip', `ui-status-chip--${status}`)}>
      <span className="ui-status-chip__icon">{STATUS_ICON[status]}</span>
      <span className="ui-status-chip__text">{children}</span>
    </span>
  )
}
